module.exports = __webpack_public_path__ + "static/media/laptop_friendly_workspace.33d2f57e.svg";